import { useEffect } from "react";

const upsertMetaTag = (selector, attributes, content) => {
  if (!content) return;
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    Object.entries(attributes).forEach(([key, value]) => {
      tag.setAttribute(key, value);
    });
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

const upsertCanonical = (href) => {
  if (!href) return;
  let link = document.head.querySelector("link[rel='canonical']");
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
};

const Seo = ({ title, description, keywords, canonical }) => {
  useEffect(() => {
    if (title) document.title = title;
    upsertMetaTag("meta[name='description']", { name: "description" }, description);
    upsertMetaTag("meta[name='keywords']", { name: "keywords" }, keywords);
    upsertMetaTag("meta[property='og:title']", { property: "og:title" }, title);
    upsertMetaTag(
      "meta[property='og:description']",
      { property: "og:description" },
      description,
    );
    upsertMetaTag("meta[property='og:type']", { property: "og:type" }, "website");
    upsertCanonical(canonical);
  }, [title, description, keywords, canonical]);

  return null;
};

export default Seo;
